module.exports = __webpack_public_path__ + "static/shoes-color-set-3-ee66e5d12d4e3d27a8a7f1a0ade301ba.png";